module.exports = __webpack_public_path__ + "static/media/Nirmal-Gram-Purskar-Certificate-Gajanan-Bhusanur.0b73f66a.jpeg";